import {
  Grid,
  InputAdornment,
  styled,
  TextField,
  TextFieldProps,
  Typography,
  FormHelperText,
} from "@mui/material";
import React from "react";

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "10%",
}));

const FullTextField = styled(TextField)(({ theme }) => ({
  width: "80%",
}));

type Props = {
  title: string;
  value: any;
  handleEdit: (e: any) => void;
  adormentRp?: boolean;
} & TextFieldProps;

export default function InputTextField({
  title,
  value,
  handleEdit,
  adormentRp = false,
  helperText,
  disabled,
}: Props) {
  return (
    <Grid container justifyContent="center">
      <DescGrid container justifyContent="center">
        <TitleGrid item xs={12}>
          <Typography component="span" variant="h6" color="black">
            {title}
          </Typography>
        </TitleGrid>
        <Grid container justifyContent="center" item xs={12}>
          {adormentRp ? (
            <FullTextField
              value={value}
              variant="outlined"
              onChange={handleEdit}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Rp.</InputAdornment>
                ),
              }}
              helperText={
                helperText ? (
                  <Typography component="span" variant="body2" color="error">
                    {helperText}
                  </Typography>
                ) : null
              }
            />
          ) : (
            <FullTextField
              multiline
              disabled={disabled}
              value={value}
              variant="outlined"
              onChange={handleEdit}
              helperText={
                helperText ? (
                  <Typography component="span" variant="body2" color="error">
                    {helperText}
                  </Typography>
                ) : null
              }
            />
          )}
        </Grid>
      </DescGrid>
    </Grid>
  );
}
